import React, { useState } from 'react';
import SignUp from './SignUp';
import OTPVerification from './OTPVerification';
import PasswordSetup from './PasswordSetup';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import { pushCleverTapEvent } from '../pushCleverTapEvent';

const AuthFlow = ({ initialStep = 'login', onClose, onAuthSuccess }) => {
  const [currentStep, setCurrentStep] = useState(initialStep);
  const [authData, setAuthData] = useState({});

  const handleSignUpNext = (data) => {
    setAuthData(prev => ({ ...prev, ...data }));
    setCurrentStep('otp');
  };

  const handleOTPNext = (data) => {
    setAuthData(prev => ({ ...prev, ...data }));
    setCurrentStep('password');
  };

  const handlePasswordNext = (data) => {
    setAuthData(prev => ({ ...prev, ...data }));
    
    // Check if auto-login was successful
    if (data.autoLogin && data.loginData) {
      // User was automatically logged in after signup
      onAuthSuccess && onAuthSuccess({
        type: 'login', // Changed to 'login' to trigger login flow in parent
        data: data.loginData,
        isAutoLoginAfterSignup: true
      });
    } else {
      // Registration complete but auto-login failed - show success notification
      onAuthSuccess && onAuthSuccess({
        type: 'signup',
        data: { ...authData, ...data }
      });
    }
  };

  const handleLoginSuccess = (data) => {
    onAuthSuccess && onAuthSuccess({
      type: 'login',
      data
    });
  };

  const handleBackToSignUp = () => {
    setCurrentStep('signup');
  };

  const handleShowLogin = () => {
    setCurrentStep('login');
    setAuthData({});
    gtag('event', 'login_click');
    pushCleverTapEvent("login_click",{'PageName': 'Login'});
  };

  const handleShowSignUp = () => {
    setCurrentStep('signup');
    setAuthData({});
    gtag('event', 'sign_up_click');
    pushCleverTapEvent("sign_up_click",{'PageName': 'Sign_up'});
  };

  const handleShowForgotPassword = () => {
    setCurrentStep('forgot');
    gtag('event', 'forgot_password');
    pushCleverTapEvent("forgot_password",{'PageName': 'Login'});
  };

  const handleBackToLogin = () => {
    setCurrentStep('login');
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 'signup':
        return (
          <SignUp
            onNext={handleSignUpNext}
            onLoginClick={handleShowLogin}
          />
        );
      
      case 'otp':
        return (
          <OTPVerification
            formData={authData.formData}
            requestId={authData.requestId}
            onNext={handleOTPNext}
            onBack={handleBackToSignUp}
            onLoginClick={handleShowLogin}
          />
        );
      
      case 'password':
        return (
          <PasswordSetup
            formData={authData.formData}
            token={authData.token}
            onNext={handlePasswordNext}
            onLoginClick={handleShowLogin}
            onClose={onClose}
          />
        );
      
      case 'login':
        return (
          <Login
            onSignUpClick={handleShowSignUp}
            onForgotPasswordClick={handleShowForgotPassword}
            onClose={onClose}
            onLoginSuccess={handleLoginSuccess}
          />
        );
      
      case 'forgot':
        return (
          <ForgotPassword
            onBackToLogin={handleBackToLogin}
            onClose={onClose}
          />
        );
      
      default:
        return (
          <Login
            onSignUpClick={handleShowSignUp}
            onForgotPasswordClick={handleShowForgotPassword}
            onClose={onClose}
            onLoginSuccess={handleLoginSuccess}
          />
        );
    }
  };

  return renderCurrentStep();
};

export default AuthFlow;
